import { formatMessage, reconciliationResultMessages } from "@/services/messages";
import { ChevronRight } from "lucide-react";

/**
 * Секция «Связанные расхождения» в карточке Discrepancy (T049, FR-013, FR-013a).
 *
 * Рендерится ТОЛЬКО когда `relatedDiscrepancyIds.length > 0` (FR-013b —
 * пустые блоки запрещены). Каждая ссылка — компактный CTA, при клике
 * вызывается `onRelatedClick(targetId)` (handler в `result.tsx` решает,
 * сделать ли scroll-to с подсветкой или показать toast при скрытой цели; R5).
 *
 * Drill-down иерархия в MVP двухуровневая (FR-013a):
 * grand-total → position. Связанные карточки рендерятся через
 * `scrollIntoView` в основном списке, а НЕ inline (FR-009 «одна Discrepancy
 * = одна карточка», FR-013c).
 */
export interface DiscrepancyRelatedSectionProps {
	relatedIds: string[];
	onRelatedClick: (targetId: string) => void;
}

export function DiscrepancyRelatedSection({
	relatedIds,
	onRelatedClick,
}: DiscrepancyRelatedSectionProps) {
	if (relatedIds.length === 0) {
		// FR-013b: пустые блоки запрещены.
		return null;
	}

	const messages = reconciliationResultMessages.drill;
	return (
		<section
			className="mt-3 rounded-md border border-blue-100 bg-blue-50/40 px-3 py-2"
			aria-label={formatMessage(messages.related_title_template, {
				count: relatedIds.length,
			})}
		>
			<h4 className="text-xs font-medium uppercase tracking-wide text-blue-900">
				{formatMessage(messages.related_title_template, { count: relatedIds.length })}
			</h4>
			<ul className="mt-1.5 flex flex-wrap gap-1.5">
				{relatedIds.map((targetId) => (
					<li key={targetId}>
						<button
							type="button"
							onClick={() => onRelatedClick(targetId)}
							className="inline-flex items-center gap-1 rounded border border-blue-300 bg-white px-2 py-0.5 text-xs font-medium text-blue-700 transition-colors hover:bg-blue-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
						>
							{messages.related_cta}
							<ChevronRight className="h-3 w-3" aria-hidden="true" />
						</button>
					</li>
				))}
			</ul>
		</section>
	);
}
